import {Market, ShopLocale} from './use-shop-locales-and-markets';

export function validLocalesForMarket(market: Market, allMarkets: Market[]) {
  if (market?.webPresences.length) {
    return [
      ...new Set(
        market.webPresences.flatMap(({defaultLocale, alternateLocales}) => [
          defaultLocale,
          ...alternateLocales,
        ]),
      ),
    ];
  } else {
    // If a market has no web presence then it inherits its locales from the shops primary market
    const primaryMarketWebPresences = allMarkets.find(
      ({primary}) => primary,
    )?.webPresences;
    return primaryMarketWebPresences?.length
      ? [
          ...new Set(
            primaryMarketWebPresences.flatMap(
              ({defaultLocale, alternateLocales}) => [
                defaultLocale,
                ...alternateLocales,
              ],
            ),
          ),
        ]
      : [];
  }
}

export function mockShopLocale(overrides?: Partial<ShopLocale>) {
  return {
    name: 'French',
    primary: false,
    published: true,
    locale: 'fr',
    machineTranslated: false,
    machineTranslatable: true,
    ...overrides,
  };
}
